import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CsCheckboxModule } from '@cs/components/checkbox';
import { CsDatepickerModule } from '@cs/components/datepicker';
import { ListFieldsFormComponent } from './list-fields-form.component';

@NgModule({
  declarations: [ListFieldsFormComponent],
			  imports: [
				  CommonModule,
				  ReactiveFormsModule,
				  FormsModule,
				  CsCheckboxModule,
				  CsDatepickerModule,
				  MatTooltipModule
			  ],
  exports: [ListFieldsFormComponent],
})
export class ListFieldsFormModule {}
